let common = {
  data() {
    return {
      queryButtonLoading: false, // 查询按钮loading
      deleteButtonLoading: false, // 删除按钮loading
      dialogOkButtonLoading: false, // 对话框确认按钮loading
      tableLoading: false, // 表格loading

      pageTotalCount: 0, // 总行数
      pageIndex: 1, // 页码
      pageSize: 10, // 每页行数
      sortKey: '', // 排序关键字
      sortDirect: '' // 排序方向
    }
  },
  methods: {
    print(type, msg) {
      if (!msg) {
        return
      }
      this.$message({
        showClose: true,
        message: msg,
        type,
        duration: 10000
      })
    },
    hasFun(funId) {
      return this.loginInfo.UserType == 0 ? true : this.loginInfo.FunIDs.indexOf(funId) != -1
    },
    pageCurrentChange(val) {
      this.pageIndex = val
      this.queryHandle()
    }
  },
  mounted() {
  }
}

export default common



// WEBPACK FOOTER //
// ./src/views/mixins/search-common.js